import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { environment } from '../../../environments/environment';

declare var FB: any;
@Component({
  selector: 'app-facebook-auth',
  templateUrl: './facebook-auth.component.html',
  styleUrls: ['./facebook-auth.component.scss'],
})
export class FacebookAuthComponent implements OnInit {
  public loading = false;
  @Input() type = 'Login';

  @Output('socialError') socialError = new EventEmitter();

  constructor(private router: Router, private authService: AuthService) {}

  ngOnInit() {
    const fbInitParams = {
      appId: environment.facebookApp.id,
      xfbml: true,
      version: environment.facebookApp.version,
    };
    if (typeof FB !== 'undefined') {
      FB.init(fbInitParams);
    }
  }

  socialAuth() {
    this.loading = true;

    if (typeof FB !== 'undefined') {
      FB.login(
        (response) => {
          if (response.authResponse) {
            this.doSocialAuth(response.authResponse.accessToken);
          } else {
            this.loading = false;
          }
        },
        { scope: 'email,public_profile' }
      );
    }
  }

  doSocialAuth(token) {
    this.authService.facebookAuth(token).subscribe(
      (res) => {
        this.router.navigateByUrl('/dashboard');
      },
      (err) => {
        this.handleError(err);
      }
    );
  }

  handleError(error) {
    this.socialError.emit(true);
    this.loading = false;
  }
}
